import React from 'react';
import BackButton from 'ui-v2/components/BackButton';
import Modal from 'ui-v2/components/Modal';
import ShimmerImage from 'core-lib/components/ShimmerImage';
import s from './ImageView.module.scss';

type ImageViewPropType = {
  show: string;
  onClose: () => void;
};
export const ImageView = ({ show, onClose }: ImageViewPropType) => {
  return (
    <Modal
      show={!!show}
      head={{
        show: false,
        onClose: onClose,
      }}
      variant="page"
      rootStyle={{
        zIndex: '12',
      }}
      animation={{
        type: 'rtl',
      }}
    >
      <div className={s.root}>
        <BackButton
          onBack={onClose}
          type="arrowLeft"
          customStyle={{
            width: 'max-content',
            position: 'absolute',
            background: 'white',
            top: 'calc(10px + var(--safe-area-top))',
            borderRadius: '50%',
            left: '20px',
            display: 'flex',
          }}
        />
        {show && <ShimmerImage src={show} className={s.image} />}
      </div>
    </Modal>
  );
};
